import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { getFirestore, doc, getDoc, query, orderBy, getDocs, collection } from "firebase/firestore";
import { auth } from "../firebase"; // your auth import

/**
 * Chat-style diary screen using saved structure:
 * {
 *   text: "...",
 *   question: "..."
 * }
 */
export default function DiaryScreen() {
  const [entries, setEntries] = useState([]);
  const db = getFirestore();

  useEffect(() => {
    async function loadJournal() {
      const user = auth.currentUser;
      const userId = user?.uid;
      if (!user) return;

      try {
      const colRef = collection(db, "journals", userId, "entries");
      const q = query(colRef, orderBy("createdAt", "desc"));
      const snap = await getDocs(q);

      const items = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setEntries(items);
    } catch (err) {
      console.error("Error loading journal:", err);
    }

    }

    loadJournal();
  }, []);

    return (
    <div
      style={{
        maxWidth: "800px",
        margin: "0 auto",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >

      {/* BACK BUTTON */}
      <button
        onClick={() => (window.location.href = "/")}
        style={{
          alignSelf: "flex-start",
          background: "transparent",
          border: "none",
          color: "#02740fff",
          fontSize: "14px",
          fontWeight: 500,
          cursor: "pointer",
          padding: "4px 0",
        }}
      >
        ← Back to Home
      </button>

      <div
        style={{
          textAlign: "center",
          padding: "16px 0",
          fontSize: "18px",
          fontWeight: 700,
          color: "#111827",
          letterSpacing: "0.3px",
          borderBottom: "1px solid #e5e7eb",
        }}
      >
        ✍️ My Ancestral Journal
      </div>

      {entries.length === 0 && (
        <p style={{ textAlign: "center", opacity: 0.7 }}>
          No ancestral messages yet.
        </p>
      )}

      <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        {entries.map((entry, i) => (
          <div key={i} style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
            
            {/* QUESTION BUBBLE */}
            {/* {entry.question && (
              <div
                style={{
                  alignSelf: "flex-end",
                  maxWidth: "70%",
                  background: "#fbfafaff",
                  padding: "12px 16px",
                  borderRadius: "18px",
                  borderTopRightRadius: "4px",
                  fontSize: "14px",
                  color: "#444",
                  boxShadow: "0 3px 8px rgba(0,0,0,0.08)",
                  marginBottom: "8px",
                }}
              >
                {entry.question}
              </div>
            )} */}

            {/* USER ENTRY */}
            <div
              style={{
                alignSelf: "flex-start",
                maxWidth: "70%",
                background: "white",
                padding: "14px 18px",
                borderRadius: "18px",
                borderTopLeftRadius: "4px",
                boxShadow: "0 4px 14px rgba(0,0,0,0.1)",
                border: "1px solid #eee",
              }}
            >
              <div style={{ fontSize: "12px", opacity: 0.6, marginBottom: "6px" }}>
                {dayjs(entry.date).format("MMMM D, YYYY")}
              </div>
              <div style={{ fontSize: "14px", marginBottom: "8px", lineHeight: 1.5 }}>{entry.answer}</div>

              {/* TRAIT TAG */}
              {entry.trait && (
                <div
                  style={{
                    display: "inline-block",
                    padding: "2px 8px",
                    fontSize: "11px",
                    background: "#eefbf0",
                    color: "#0a7a1c",
                    borderRadius: "6px",
                    marginBottom: "8px",
                  }}
                >
                  {entry.trait}
                </div>
              )}

              <div style={{ fontSize: "14px", lineHeight: 1.5 }}>{entry.text}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
